import React, { Fragment } from 'react';
import { SURVEY_CREATION_CONSTANT } from '../../../../constants/FrontEndConstant';
import { LANGUAGE_CODE } from '../../../../constants/DotEnv';
class SurveyCategory extends React.Component {
    render() {
        let onClickFunction = this.props.onUpdate;
        let fieldName = this.props.fieldName;
        let surveyContent;
        if (fieldName) {
            surveyContent = this.props.data.surveyContent;
        } else {
            surveyContent = this.props.AllData.surveyData.surveyContent;
        }
        let index = this.props.index;
        let optionId;
        let optionText;
        if (surveyContent) {
            if (surveyContent[index]) {
                optionId = surveyContent[index].id;
                optionText = surveyContent[index].content_text.replace(/<br\s*\/?>/mg, "");
            }
        }
        if (optionText) {
            optionText = optionText.replace(/<br\s*\/?>/mg, "");
        }
        return (
            <Fragment>
                <div id={"d-flex align-items-center mt-4 removeText-" + index} className={"d-flex align-items-center mt-4 removeText-" + index}>
                    <div id="errorSurveyMessage" className="error-text"></div>
                    <textarea rows="4" cols="35" id={optionId} data-value={index} className="text-msg text-area-design get-text" wrap="soft" name={"survey_welcome_text"} onChange={onClickFunction} value={optionText} defaultValue={optionText} placeholder={SURVEY_CREATION_CONSTANT[LANGUAGE_CODE]['survey_content_page_text_placeholder']}/>
                    <button className="btn p-0 icon-del w-auto" onClick={onClickFunction} type="button" name="removeText" id={optionId} value={index}><i className="fas fa-trash"></i></button>
                </div>
            </Fragment>
        );
    }
}
export default SurveyCategory;